export default __webpack_public_path__ + "static/media/Trash.8c97b66f.svg";